import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  restartNotificationCounter: false,
  materialNotifications: null,
  equipmentNotifications: null,
  manpowerNotifications: null,
  sowNotifications: null,
  notificationData: [],
  unreadNotification: [],
}

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotificationData(state, action) {
      state.notificationData = action.payload;
    },
    setUnreadNotification(state, action) {
      state.unreadNotification = action.payload;
    },
    setRestartNotificationCounter(state, action) {
      state.restartNotificationCounter = action.payload;
    },
    setMaterialNotifications(state, action) {
      state.materialNotifications = action.payload;
    },
    setEquipmentNotifications(state, action) {
      state.equipmentNotifications = action.payload;
    },
    setManpowerNotifications(state, action) {
      state.manpowerNotifications = action.payload;
    },
    setSowNotifications(state, action) {
      state.sowNotifications = action.payload;
    }
  }
})

export const {
  setRestartNotificationCounter,
  setMaterialNotifications,
  setEquipmentNotifications,
  setManpowerNotifications,
  setSowNotifications,
  setUnreadNotification,
  setNotificationData
} = notificationSlice.actions;

export default notificationSlice.reducer;
